import {PageCard} from '../../../../layout/page-card/page-card';
import {ShortCatalogType} from '../../../../provider/catalogs/catalogs-type';

import {AccountLinkingFacebook} from './account-linking-facebook';

type PropsType = {
    catalogInfo: ShortCatalogType;
};

export function AccountLinkingFacebookCard(props: PropsType): JSX.Element {
    const {catalogInfo} = props;

    return (
        <PageCard title={catalogInfo.name}>
            <AccountLinkingFacebook catalogInfo={catalogInfo} />
        </PageCard>
    );
}
